import { Typography } from "antd";
import { FILE_BASE_URL } from "../../../config";
import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { updatePosterKey } from "../../../store/poster/thunks";
import PrintableImage from "../../../components/shared/PrintableImage";
const { Link } = Typography;
const PosterContentRenderer = ({ record }) => {
  const dispatch = useDispatch();

  const onError = useCallback(async () => {
    return await dispatch(
      updatePosterKey({
        poster_id: record?.id,
        tenant_id: record?.tenant_id,
      }),
    );
  }, [record]);

  switch (record.type) {
    case "text":
      return (
        <div className="ellipsis-text" style={{ width: "500px" }}>
          {record.content}
        </div>
      );

    case "photo":
      return (
        <PrintableImage
          onError={onError}
          src={`${FILE_BASE_URL}${record.content}`}
          alt="poster"
          width={100}
          height={60}
          style={{
            objectFit: "cover",
            borderRadius: 6,
          }}
          isDoc
        />
      );

    case "link":
      return (
        <div className="ellipsis-text" style={{ width: "500px" }}>
          <Link href={record.content} target="_blank" rel="noopener noreferrer">
            {record.content}
          </Link>
        </div>
      );

    default:
      return "-";
  }
};

export default PosterContentRenderer;
